exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".quotePMargin[data-v-68357086]{margin:0;text-align:left!important}.md-direction-bottom-right[data-v-68357086]{width:18%!important}.md-flex-xsmall-100[data-v-68357086]{min-width:100%;flex:0 1 100%}.center[data-v-68357086]{text-align:center}.b-form-input-container[data-v-68357086]{margin:4px 0 12px!important}.activeClass[data-v-68357086]{display:none}.error[data-v-68357086]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68357086","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/freightForwarding/agentColoader/upsertAgentUser.vue
// module id = 1666
// module chunks = 0